import cn from "classnames";
import { ChangeEvent } from "react";
import { SliderProps } from "./types";
import { DEFAULT_MIN, DEFAULT_MAX, DEFAULT_STEP } from "./constants";
import { getFilledTrackWidth } from "./utils";
import styles from "./styles.module.scss";

export const Slider = ({
  value,
  min = DEFAULT_MIN,
  max = DEFAULT_MAX,
  step = DEFAULT_STEP,
  hint,
  className,
  onChange,
  error = false,
  disabled = false,
  withLabel = true,
  dataTestId = "slider",
}: SliderProps) => {
  const { value: minValue, label: minLabel } = min;
  const { value: maxValue, label: maxLabel } = max;

  const filledTrackWidth = getFilledTrackWidth(minValue, maxValue, step, value);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event, { value: +event.target.value });
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <span
        className={cn(styles["filled-track"], {
          [styles.error]: error,
          [styles.disabled]: disabled,
        })}
        style={{ width: filledTrackWidth }}
        data-test-id={`${dataTestId}-filled-track`}
      />
      <input
        type="range"
        title="slider"
        className={cn(styles.slider, {
          [styles.error]: error,
          [styles.disabled]: disabled,
        })}
        step={step}
        value={value}
        min={minValue}
        max={maxValue}
        disabled={disabled}
        onChange={handleChange}
        data-test-id={dataTestId}
      />
      {!hint && withLabel && (
        <p
          className={cn(styles.label, { [styles.error]: error })}
          data-test-id={`${dataTestId}-label`}
        >
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </p>
      )}
      {hint && (
        <p
          className={cn(styles.hint, { [styles.error]: error })}
          data-test-id={`${dataTestId}-hint`}
        >
          {hint}
        </p>
      )}
    </div>
  );
};
